import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { computed } from '@ember/object';

import SubscriptionTopicUsage, {
  isUsedInRunningBroadcast,
  isUsedInRunningCampaign,
  isUsedInScheduledOrRunningNewsletter,
} from 'cio/utils/subscription-topic-usage';
import { bool } from '@ember/object/computed';

const TOPIC_PREFERENCE_PREFIX = 'topic_';

export default class SubscriptionTopicModel extends Model {
  @attr('string') name!: string;
  @attr('string') description!: string;
  @attr('boolean', { defaultValue: false }) optIn!: boolean;
  @attr('number') created!: number;
  @attr('number') updated!: number;
  @attr('camel-case') usage!: SubscriptionTopicUsage;
  @bool('optIn') isOptIn!: boolean;

  @computed('usage')
  get canBeDeleted() {
    // isNew does not have the right type
    if ((this.isNew as unknown as boolean) === true) {
      return true;
    }
    return (
      !this.usage?.campaigns.some(isUsedInRunningCampaign) &&
      !this.usage?.newsletters.some(isUsedInScheduledOrRunningNewsletter) &&
      !this.usage?.broadcasts.some(isUsedInRunningBroadcast)
    );
  }

  @computed('id')
  get identifier() {
    return `${TOPIC_PREFERENCE_PREFIX}${this.id}`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    subscriptionTopic: SubscriptionTopicModel;
  }
}
